// extracted by mini-css-extract-plugin
module.exports = {"ExampleData":"ExampleData_ExampleData__3YsNj","Table":"ExampleData_Table__2_622","LeftCell":"ExampleData_LeftCell__1GRkg","RightCell":"ExampleData_RightCell__2_xlj"};